import getTaskFolderName from '../utils/getTaskFolderName';
import { getProject, timeStreamProjectUpdated } from 'owa-timestream-store';
import { updateTaskFolderService } from 'owa-todo-service';
import { orchestrator } from 'satcheljs';

orchestrator(timeStreamProjectUpdated, ({ projectId, outlookSpace }) => {
    const { tasksParentFolderId } = getProject(projectId);
    if (!!tasksParentFolderId && !!outlookSpace.name) {
        updateTaskFolderService(tasksParentFolderId, {
            Name: getTaskFolderName(outlookSpace.name),
        });
    }
});
